import { useEffect, useState } from 'react';
import { useFirestoreGeneral } from '../../firebase/useFirestore';
import Location from '../../hooks/Location';
import PageHeader from '../layout/PageHeader.jsx';
import TaskEditor from './TaskEditor';
import { useTaskDTO } from '../../hooks/firebase/TaskDto.jsx';

/**
 * @typedef {import('../../hooks/firebase/TaskDto.jsx').Task} Task
 * @typedef {import('../../hooks/firebase/TaskDto.jsx').TaskDTO} TaskDTO
 * @typedef {'view' | 'create' | 'edit'} TaskEditorAction
 */

const TaskDetails = () => {

    // Hooks
    const taskId = Location()[3];

    const taskDTO = useTaskDTO();

    /** @type {ReturnType<typeof useState<Task | null>>} */
    // const [task, setTask] = useState(null);

    // useEffect(() => {
    //     if (!taskDTO) return;

    //     const fetchTask = async () => {
    //         const fetchedTask = await taskDTO.get(taskId);
    //         setTask(fetchedTask);
    //     };
        
    //     fetchTask();
    // }, [taskId, taskDTO]);

    // Firestore
    /** @type {Task[]} tasks */
    const tasks = /** @type {Task[]} */ (
        useFirestoreGeneral('Tasks', 'ID', taskId || '')
    );

    const task = tasks && tasks?.length > 0 ? tasks[0] : null;

    if (!task) {
        return <div>Taak niet gevonden.</div>;
    }

    return (
        <div className="main">
            <div className="main-container">
                <PageHeader
                    heading={'Taak instellingen'}
                    subHeading={``}
                    description={`Het instellingen overzicht van deze taak`}
                    AI={false}
                />
                <div id="live-report-builder-content-container">
                    {task && (
                        <TaskEditor
                            task={task}
                            action={'edit'}
                            onTaskChange={async task => {
                                await taskDTO.save(task); // Uses Firebase state, instant update
                            }}
                            // onSave={async task => {
                            //     // await taskDTO.save(task) // Submit button, not used currently
                            // }}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default TaskDetails;
